import axios from "const/axios";
import { useQuery } from "@tanstack/react-query";
import { API_URL } from "const/constants";

export const fetchCreditAdjustmentOptions = (termId) =>
  axios
    .get(`${API_URL}/admission-terms/${termId}/credit-adjustment/options`)
    .then((r) => r.data?.data ?? null);

export const useCreditAdjustmentOptions = (termId, enabled) =>
  useQuery({
    queryKey: ["credit-adjustment-options", termId],
    queryFn: () => fetchCreditAdjustmentOptions(termId),
    enabled: Boolean(enabled) && termId != null,
    refetchOnWindowFocus: false,
    // Credit and dues move with every payment, so each opening asks the server again.
    staleTime: 0,
    refetchOnMount: "always",
  });

export const requestCreditAdjustment = (termId, { targetTermId, amount, reason, applyNow }) =>
  axios
    .post(`${API_URL}/admission-terms/${termId}/credit-adjustment`, {
      targetTermId,
      amount,
      reason,
      applyNow: Boolean(applyNow),
    })
    .then((r) => r.data?.data ?? null);
